import React from 'react';
import { NativeSelectOption, NativeSelectOptionProps } from '~app/components/core/NativeSelect';

export type SelectOptionProps = NativeSelectOptionProps;

function SelectOption(props: SelectOptionProps): React.ReactElement {
  return <NativeSelectOption {...props} />;
}

export default SelectOption;
